import { threadCards } from "@/mocks/home";

const toneMap: Record<string, { chip: string; dot: string }> = {
  live: { chip: "bg-primary-100 text-primary-700", dot: "bg-primary-500" },
  wait: { chip: "bg-secondary-100 text-secondary-800", dot: "bg-secondary-400" },
  doubt: { chip: "bg-accent-100 text-accent-800", dot: "bg-accent-500" },
};

export default function FollowGrid() {
  return (
    <section id="follow" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-primary-600">
              <span className="h-4 w-1 rounded bg-primary-500" />
              焦点档案 · 大图卡片流
            </p>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              正在跟进的线索
            </h2>
          </div>
          <a href="#briefing" className="group flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600">
            查看全部速览
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
          {threadCards.map((t) => {
            const meta = toneMap[t.tone];
            return (
              <article key={t.id} className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
                <div className="relative h-44 w-full overflow-hidden md:h-48">
                  <img
                    src={t.img}
                    alt={`51吃料 持续更新 ${t.channel}线：${t.title}`}
                    className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                  <div className="absolute left-3 top-3 flex items-center gap-2">
                    <span className="rounded-md bg-foreground-950/70 px-2 py-1 text-[11px] font-semibold text-background-50 backdrop-blur-sm">
                      {t.channel}
                    </span>
                  </div>
                  <span className="absolute right-3 top-3 whitespace-nowrap rounded-md bg-background-50/90 px-2 py-1 text-[11px] text-foreground-700 backdrop-blur-sm">
                    {t.days}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4 md:p-5">
                  <div className="flex items-center gap-2">
                    <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-semibold ${meta.chip}`}>
                      <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} />
                      {t.status}
                    </span>
                    <span className="ml-auto text-[11px] text-foreground-400">{t.updated}</span>
                  </div>
                  <h4 className="mt-3 font-heading text-[16px] font-black leading-snug text-foreground-950">
                    {t.title}
                  </h4>
                  <p className="mt-2 text-[13px] leading-6 text-foreground-600">{t.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1 border-t border-background-200 pt-3 text-xs font-semibold text-primary-600">
                    进入档案
                    <i className="ri-corner-down-right-line" />
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}